<div *ngFor="let video of [videoStreamService.videoSourceOne, videoStreamService.videoSourceTwo]; 
let windowNo = index;" class="video-feed">
	<div class="player-view" *ngIf="video.url">
		<div class="video-window-header">
			<select [(ngModel)]="windowVideos[windowNo]" class="video-dropdown"
				(change)="videoStreamService.setVideoSource(windowNo, windowVideos[windowNo])">
				<option *ngFor="let v of videoStreamService.videoFeeds;let i=index" [value]="i">{{ v?.name }}
				</option>
			</select>
			<div class="video-control-bar" [class.disabled]="video.invalidUrl">
				<img class="ctrl-icon" alt="unshare_video" (click)="unShareVideo(windowNo)"
					[title]="'VIDEO_CONTROL.UNSHARE' | translate" [src]="utility.getImagePath('unshare_video.png')" />
				<img class="ctrl-icon" alt="share_video" (click)="shareVideo(windowNo)"
					[title]="'VIDEO_CONTROL.SHARE' | translate" [src]="utility.getImagePath('share_video.png')" />
				<i class="fa fa-hand-pointer-o ctrl-icon" aria-hidden="true" (click)="controlVideo(windowNo,video)"
					[title]="'VIDEO_CONTROL.CONTROL' | translate"></i>
				<img class="ctrl-icon" alt="full_scrn_video" (click)="showFullScreenVideo(video)"
					[title]="'VIDEO_CONTROL.FULL_SCREEN' | translate" [src]="utility.getImagePath('full_scrn_video.png')" />
			</div>
		</div>

		<div class="iframe_container" *ngIf="!video.invalidUrl && streamEngineServerUrl">
			<rse-player
				[serverUrl]="streamEngineServerUrl"
				[url]="asSourceUrl(video.url)"
				[appToken]="streamAppToken"
				[muted]="true"
			></rse-player>
		</div>
		<div *ngIf="video.invalidUrl" class="invalid">{{"VIDEO_FEED.INVALID_URL" | translate}}</div>
		<div *ngIf="!video.invalidUrl && !streamEngineServerUrl" class="invalid">{{"VIDEO_FEED.NO_VIDEO" | translate}}</div>

	</div>

	<div *ngIf="!video.url">{{"VIDEO_FEED.NO_VIDEO" | translate}}</div>

</div>
